import { IAsyncActionCallback } from '@state/types';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';

export const fetchUserFiles = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchUserFilesAction => {
  return {
    type: actionsTypes.FETCH_USERFILES,
    query,
    callback
  };
};

export const addUserFiles = (userFiles: actionsInterfaces.IUserFiles, callback: IAsyncActionCallback): actionsInterfaces.IPostUserFilesAction => {
  return {
    type: actionsTypes.ADD_USERFILES,
    userFiles,
    callback
  };  
};

export const getUserFiles = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchUserFilesAction => {
  return {
    type: actionsTypes.GET_USERFILES_INFO,
    query,
    callback
  };  
};

export const setUserFiles = (userFiles: actionsInterfaces.IUserFiles): actionsInterfaces.ISetUserFilesAction => {
  return {
    type: actionsTypes.SET_USERFILES_INFO,
    userFiles,
  };
};

export const addSuccess = (response: {})=> {
  return {
    type: actionsTypes.ADD_SUCCESS,
    response,
  };
};

export const fetchSearchUserFiles = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchSearchAction => {
  return {
    type: actionsTypes.FETCH_SEARCH_USERFILES,
    query,
    callback
  };
};

export const setSearch = (searchesUserFiles: actionsInterfaces.IUserFiles): actionsInterfaces.ISetSearchAction => {
  return {
    type: actionsTypes.SET_SEARCH_USERFILES,
    searchesUserFiles,
  };
};

export const updateUserFiles = (userFiles: actionsInterfaces.IUserFiles, callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateUserFilesAction => {
  return {
    type: actionsTypes.UPDATE_USERFILES,
    userFiles,
    callback
  };
};

export const deleteUserFiles = (userFiles: actionsInterfaces.IUserFiles, callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateUserFilesAction => {
  return {
    type: actionsTypes.DELETE_USERFILES,
    userFiles,
    callback
  };
};

export const bulkDeleteUserFiles = (userFiles: string[], callback?: (result: any, error: any) => void): actionsInterfaces.IBulkDeleteFilesAction => {
  return {
    type: actionsTypes.BULK_DELETE_USERFILES,
    userFiles,
    callback,
  };
}

export const fetchCounter = (filter?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchCounterAction => {
  return {
    type: actionsTypes.FETCH_COUNTER,
    filter,
    callback
  };
};

export const setCounter = (counter: actionsInterfaces.IUserFiles): actionsInterfaces.ISetCounterAction => {
  return {
    type: actionsTypes.SET_COUNTER,
    counter,
  };
};